import { IconProps } from './type';

export const ICReceipt: React.FC<IconProps> = ({
    width = 20,
    height = 20,
    className,
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 128 128"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M30 18H98V110L88 104L78 110L68 104L58 110L48 104L38 110L30 104V18Z"
                fill="#4f4b5c"
            />
            <rect x="42" y="34" width="44" height="8" rx="4" fill="#D9A5A5" />
            <rect x="42" y="52" width="34" height="6" rx="3" fill="#374151" />
            <rect x="42" y="66" width="44" height="6" rx="3" fill="#374151" />
            <circle cx="88" cy="88" r="18" fill="#D9A5A5" />
            <path
                d="M88 78V98"
                stroke="white"
                strokeWidth="6"
                strokeLinecap="round"
            />
            <path
                d="M78 88H98"
                stroke="white"
                strokeWidth="6"
                strokeLinecap="round"
            />
        </svg>
    );
};
